import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';
import FD from '../../RestAPI/fetchData';
import SignUpApproval from '../../Common/signUpApproval';

import TagManager from 'react-gtm-module';
import cookie from 'react-cookies';
import language from '../../../assets/languages/language';
import {
  ActuarialExamList,
  CFAExamList,
  FRMExamList,
  GA4SignUp,
  GMATExamList,
  GTM_ID,
  GTMSignUp,
} from '../../../common/constant';
import { examRedirectRoute } from '../../Common/examRedirectRoute';
class Selectexam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exam: '',
      message: '',
      message_background: 'bg-danger',
      displaytext: 'hide_block',
      token: '',
      idname: '',
      signupAlert: false,
      landingSource: 'organic',
      landingSourceName: null,
      name: this.props.params.name ? this.props.params.name : null,
    };
    this.saveExam = this.saveExam.bind(this);
    this.signUpAlertModel = this.signUpAlertModel.bind(this);
    this.signUpAlertModelClose = this.signUpAlertModelClose.bind(this);
  }

  signUpAlertModel() {
    this.setState({ signupAlert: !this.state.signupAlert });
  }

  signUpAlertModelClose() {
    this.setState({ signupAlert: false });
    browserHistory.push('/');
  }
  saveExam() {
    if (document.getElementById('exam_field').value === '') {
      this.setState({ displaytext: 'show_block' });
      this.setState({ message: 'Exam Field Is Required' });
      return;
    } else {
      const role = localStorage.getItem('role');
      const organizationDomain = localStorage.getItem('organizationDomain');

      const data = {
        idname: this.state.idname,
        token: this.state.token,
        examfield: document.getElementById('exam_field').value,
        organizationDomain,
        role,
        landingSource: this.state.landingSource,
        landingSourceName: this.state.landingSourceName,
      };

      FD.callAPI(`${App_data.backend_api}/user/updateUser`, data).then((resp) => {
        if (resp.success) {
          /*
          -------------------------
            GTM signup event code
          -------------------------
          */

          // if (this.state.landingSource) {
          const tagManagerArgs = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GTMSignUp,
              eventOptions: { selectedExam: document.getElementById('exam_field').value },
              userName: this.state.name,
              userEmail: this.state.idname,
              userExam: document.getElementById('exam_field').value,
              source: this.state.landingSource,
              affiliateName: this.state.landingSourceName,
            },
          };
          TagManager.initialize(tagManagerArgs);

          // ******************* Event for Sign Up in GA4 ************** //
          const tagManagerArgsGA4 = {
            gtmId: GTM_ID,
            dataLayer: {
              event: GA4SignUp,
              method: this.state.idname,
            },
          };
          TagManager.initialize(tagManagerArgsGA4);
          // }

          localStorage.setItem('selectedmenu', document.getElementById('exam_field').value);
          const exam_status = document.getElementById('exam_field').value;
          if (exam_status) {
            localStorage.setItem('selectedmenu', exam_status);
            browserHistory.push({ pathname: examRedirectRoute[exam_status] });
          }
        }
      });
    }
  }

  componentDidMount() {
    /*
--------------------------------
  Pixel Integration code start
--------------------------------
*/
    const landingSourceCokkie = cookie.load('utm_source', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (landingSourceCokkie) {
      this.setState({ landingSource: landingSourceCokkie });
    }
    localStorage.setItem('landingSource', landingSourceCokkie ? landingSourceCokkie : null);
    const checkTapfilliateRefernce = cookie.load('ref', {
      path: '/',
      domain: '.analystprep.com',
    });
    if (checkTapfilliateRefernce) {
      this.setState({
        landingSource: 'tapfiliate',
        landingSourceName: checkTapfilliateRefernce,
      });
      localStorage.setItem('landingSource', 'tapfiliate');
    }

    localStorage.setItem(
      'landingSourceName',
      checkTapfilliateRefernce ? checkTapfilliateRefernce : null,
    );
    /*
-------------------------------
  Pixel Integration code end
-------------------------------    
    */

    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (!storage_session) {
      browserHistory.push('/');
    }
  }

  render() {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper'>
            <img src={`${App_data.frontend_url}/img/logo1.png`} alt='' width='200' />
          </div>
        </div>
        <div className='row justify-content-center'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-4'>
            <div className='card-group mb-0'>
              <div className='card p-2  '>
                <div className='card-block'>
                  <h4>Select Exam</h4>
                  <p className='text-muted'>Fill Your Details</p>
                  <p
                    className={`${this.state.message_background} ${this.state.displaytext}`}
                    style={{
                      paddingTop: `${4}px`,
                      paddingBottom: `${4}px`,
                      paddingLeft: `${10}px`,
                      fontSize: `${14}px`,
                    }}
                  >
                    {this.state.message}
                  </p>

                  <div className='input-group mb-1'>
                    <span className='input-group-addon-social-registration'>
                      <i className='fa fa-book' />
                    </span>
                    <select className='form-control' id='exam_field'>
                      {[
                        { value: '', label: language.LC().SELECT_EXAM },
                        ...CFAExamList(),
                        ...FRMExamList,
                        ...ActuarialExamList,
                        ...GMATExamList,
                      ].map(({ value, label }) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='row'>
                    <div className='col-md-12'>
                      <button
                        type='button'
                        style={{ width: `${100}%` }}
                        className='btn btn-primary'
                        onClick={this.saveExam}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SignUpApproval
          signUpAlertModel={this.signUpAlertModel.bind(this)}
          signUpAlertModelClose={this.signUpAlertModelClose.bind(this)}
          signupAlert={this.state.signupAlert}
        />

        <blockquote className='footer-blockquote'>
          <p>{language.LC().FOOTER_MESSAGE}</p>
          <span className='ml-1'>
            <a href='https://analystprep.com/privacy/' target='_blank' className='privacy-policy'>
              {language.LC().Privacy_Policy}
            </a>
          </span>
        </blockquote>
      </div>
    );
  }
}

export default Selectexam;



// WEBPACK FOOTER //
// ./src/views/Pages/Selectexam/Selectexam.js